import { shouldForceOAuthBinding } from '@/utils/oauthBinding.js'

export default async function ({ route, store, redirect, env, app, $axios, $auth }) {
  const hasOauthParams = Boolean(route.query.state && route.query.id && route.query.provider)
  const isNewUser = String(route.query.is_new_user || '').toLowerCase() === 'true'
  const isForceOauthBinding = route.name === 'auth-force-oauth' ||
    route.query.force_oauth_binding === '1' ||
    Boolean(hasOauthParams && $auth.loggedIn && $auth.user?.force_oauth_login)
  const getStoredRememberUrl = () => {
    if (!process.client) return ''
    return window.sessionStorage.getItem('force_oauth_remember_url') || ''
  }
  const clearStoredRememberUrl = () => {
    if (process.client) {
      window.sessionStorage.removeItem('force_oauth_remember_url')
    }
  }
  const setStoredBindingStatus = (status) => {
    if (process.client) {
      window.sessionStorage.setItem('force_oauth_binding_status', status)
    }
  }
  const notifyStoredBindingStatus = () => {
    if (!process.client) return
    const status = window.sessionStorage.getItem('force_oauth_binding_status')

    if (!status) return

    window.sessionStorage.removeItem('force_oauth_binding_status')

    if (status === 'success') {
      app.$message.success('Способ входа привязан')
    } else {
      app.$message.error('Не получилось привязать способ входа')
    }
  }
  notifyStoredBindingStatus()
  const fetchFullCurrentUser = async () => {
    if (!$auth.user?.id) return $auth.user

    try {
      return await $axios.$get(`/users/${$auth.user.id}/`)
    } catch (e) {
      return $auth.user
    }
  }

  if (hasOauthParams) {
    const rememberUrl = route.query.remember_url || (isForceOauthBinding ? getStoredRememberUrl() : '')
    const payload = {
      provider: route.query.provider,
      state: route.query.state,
      id: route.query.id
    }

    if (isForceOauthBinding && !$auth.loggedIn) {
      setStoredBindingStatus('error')
      return redirect({
        path: '/',
        query: { remember_url: rememberUrl || '/' }
      })
    }

    if (isForceOauthBinding) {
      try {
        await $axios.post(`${env.BASE_URL_V2}/auth/link_with/`, payload)
        await $auth.fetchUser()

        if ($auth.user?.force_oauth_login) {
          await $auth.setUser({
            ...$auth.user,
            force_oauth_login: false
          })
        }

        setStoredBindingStatus('success')
        clearStoredRememberUrl()

        if (rememberUrl) {
          return redirect(rememberUrl)
        }

        return redirect('/')
      } catch (e) {
        setStoredBindingStatus('error')
        return redirect({
          name: 'auth-force-oauth',
          query: rememberUrl ? { remember_url: rememberUrl } : {}
        })
      }
    }

    if (!$auth.loggedIn && isNewUser && !isForceOauthBinding) {
      store.dispatch('auth_modals/showNicknameModal', true)
    } else {
      try {
        const response = await $axios.post(`${env.BASE_URL_V2}/auth/login_with/`, payload)

        if (response.data && response.data.access_token) {
          await $auth.setUserToken(response.data.access_token);
          await $auth.fetchUser();

          if (shouldForceOAuthBinding(await fetchFullCurrentUser())) {
            const forceOauthQuery = rememberUrl
              ? { remember_url: rememberUrl }
              : {}

            return redirect({
              name: 'auth-force-oauth',
              query: forceOauthQuery
            })
          }

          app.$message.success('Вы успешно авторизовались')

          if (rememberUrl) {
            return redirect(rememberUrl)
          }
        }
      } catch (e) {
        app.$message.error('Что-то пошло не так')
      }
    }

    return
  }

  if (!$auth.loggedIn) {
    if (route.query.remember_url) {
      store.dispatch('auth_modals/rememberUrl', route.query.remember_url)
      if (!hasOauthParams) {
        store.dispatch('auth_modals/showAuthModal', true)
      }
    }
  } else {
    if (route.query.remember_url) {
      if (route.name === 'auth-force-oauth' || shouldForceOAuthBinding(await fetchFullCurrentUser())) {
        return
      }

      redirect(route.query.remember_url)
    }
  }
}

